import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Form, Icon, Message, Modal,
} from 'semantic-ui-react';
import { isEmpty } from 'lodash';

const CREATE = 'Create';
const UPDATE = 'Update';
const CLEAR = 'Clear';

const headerStyle = {
  display: 'grid',
  justifyContent: 'space-between',
  gridTemplateColumns: 'auto auto',
};

class SubscriptionNotesForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notesContent: props.customerNotes ? props.customerNotes.message : '',
      action: CREATE,
      confirmUpdating: false,
      errors: {},
    };
  }

  componentDidMount() {
    const { notesContent } = this.state;
    if (notesContent === undefined) {
      this.setState({ notesContent: '' });
    }
    if (this.isCreate()) {
      this.setState({ action: CREATE });
    } else {
      this.setState({ action: UPDATE });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { action } = this.state;
    if (prevState.action !== action) {
      this.handleFormStateChange();
    }
  }

  onNotesChangeHandler = field => event => {
    const { action } = this.state;
    if (field === 'notesContent') {
      if (!isEmpty(event.target.value)) {
        const actionTmp = this.isCreate() ? CREATE : UPDATE;
        this.setState({
          [field]: event.target.value,
          errors: { [field]: '' },
          action: actionTmp,
        });
        return true;
      }
      if (action === CREATE) {
        this.setState({
          [field]: event.target.value,
          errors: { [field]: 'Notes can not be empty' },
          action: CREATE,
        });
      } else if (action === UPDATE) {
        this.setState({ [field]: event.target.value, action: CLEAR });
      }
      return false;
    }
    return false;
  };

  isCreate = () => {
    const { customerNotes } = this.props;
    return (
      customerNotes === undefined
      || customerNotes.noteId === null
    );
  };

  showTitleModal = () => {
    const { action } = this.state;
    if (action === UPDATE) {
      return 'Edit notes';
    }
    return 'Create notes';
  };

  handleFormStateChange = () => {
    // Notify the parent component about the action
    const { onStateChange } = this.props;
    const { action } = this.state;
    if (typeof onStateChange === 'function') {
      onStateChange(action);
    }
  };

  handleSubmit = () => {
    const { notesContent, action } = this.state;
    const { onSubmitHandler } = this.props;

    this.setState({ confirmUpdating: true });
    if (action === CREATE && isEmpty(notesContent)) {
      this.setState({
        errors: {
          notesContent: 'This field is required',
        },
      });
      return false;
    }

    onSubmitHandler({
      message: notesContent,
    });
    return true;
  };

  confirmSubmitNotes = () => {
    this.setState({ confirmUpdating: true });
  };

  render() {
    const {
      errors, confirmUpdating, notesContent, action,
    } = this.state;
    const {
      isModalOpen,
      onCloseHandler,
      error,
      submitting,
    } = this.props;

    const maxLengthNotes = 50;
    const countRestOfNotes = notesContent
      ? maxLengthNotes - notesContent.length
      : maxLengthNotes;

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header style={headerStyle}>
          <span>{this.showTitleModal()}</span>
        </Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}

            <Form>
              <Form.Group>
                <Form.Field
                  style={{ width: '100%' }}
                  required
                  error={!isEmpty(errors.notesContent)}
                >
                  <label htmlFor='notesContent'>Notes</label>
                  <input
                    id='notesContent'
                    style={{ width: '100% !important' }}
                    name='notesContent'
                    value={notesContent}
                    onChange={this.onNotesChangeHandler('notesContent')}
                    maxLength={maxLengthNotes}
                  />
                  <span style={{ color: '#9f3a38', paddingLeft: '500px;' }}>
                    Remaining characters: {countRestOfNotes}
                  </span>

                  {errors.notesContent && (
                    <div style={{ color: 'red' }}>{errors.notesContent}</div>
                  )}
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}
          {!submitting && !confirmUpdating && (
            <Button color='green' onClick={this.confirmSubmitNotes} inverted>
              <Icon name='checkmark' /> {action}
            </Button>
          )}
          {confirmUpdating && !submitting && (
            <Button color='green' onClick={this.handleSubmit} inverted>
              <Icon name='checkmark' /> Are You Sure?
            </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

SubscriptionNotesForm.propTypes = {
  customerNotes: PropTypes.shape({
    message: PropTypes.string,
    noteId: PropTypes.number,
  }),
  onStateChange: PropTypes.func,
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
};

SubscriptionNotesForm.defaultProps = {
  customerNotes: {
    message: '',
    noteId: null,
  },
  onStateChange: () => {},
  isModalOpen: false,
  error: null,
  submitting: false,
};

export default SubscriptionNotesForm;
